<template>
  <transition name="explainStop-fade">
    <div class="explainStop" v-show="state===1" >
        <!-- @touchmove.prevent -->
      <div class="explainStop-wrappper" @click.stop>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>
<script>
  import BScroll from 'better-scroll'
  const STATE_HIDE = 0
  const STATE_SHOW = 1
  const COMPONENT_NAME = 'explainStop'
  export default {
    name: COMPONENT_NAME,
    props: {
      data: {
        type: Array,
        default () {
          return []
        }
      },
      title: {
        type: String
      },
      cancelTxt: {
        type: String,
      },
      confirmTxt: {
        type: String,
      },
      selectedIndex: {
        type: Array,
        default () {
          return []
        }
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        state: STATE_HIDE,
      }
    },
    methods: {
      confirm() {},
      cancel() {
        this.hide()
      },
      show() {
        this.state = STATE_SHOW
      },
      hide() {
        this.state = STATE_HIDE
      },
    },
  }

</script>

<style scoped>
  .explainStop {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(0, 0, 0, .8);
    color: #fff;
  }


  .explainStop-fade-enter,
  .explainStop-fade-leave-active {
    opacity: 0
  }

  .explainStop-fade-enter-active,
  .explainStop-fade-leave-active {
    transition: all .3s ease-in-out;
  }

</style>
